function invalidKey(verb) {
  throw new Error(`${verb}: key must be a non-empty string`);
}
function invalidValue(verb) {
  throw new Error(`${verb}: value must be a string`);
}
export {
  invalidKey,
  invalidValue
};
//# sourceMappingURL=validate.js.map
